import { histogramPlot, periodInput } from "../definitionHelpers";
import { COLOR_RULE } from "../indicatorTypes";
import { fillAwesomeOscillator } from "../math/awesomeOscillator";

/**
 * Awesome Oscillator (research §1.4), as TV Awesome Oscillator (there the
 * periods are fixed at 5 / 34, here they are the PO inputs): SMA of hl2
 * over Short minus SMA over Long. A column is up when higher than the
 * previous one, as in TV.
 */
export default {
  id: "awesome-oscillator",
  name: "Awesome Oscillator",
  isOscillator: true,
  inputs: [
    periodInput("shortPeriod", "Short", 5),
    periodInput("longPeriod", "Long", 34),
  ],
  plots: [
    histogramPlot("value", "Main Line", COLOR_RULE.TREND),
  ],
  levels: [],

  calculate: (bars, { shortPeriod, longPeriod }, series, fromIndex) => {
    fillAwesomeOscillator({ bars, shortPeriod, longPeriod, target: series.value, fromIndex });
  },
};
